// Browser-safe logger — no Node.js deps. Matches the Winston server format so
// log aggregators see a consistent shape regardless of runtime.

function nowTimestamp(): string {
    return new Date().toISOString().replace('T', ' ').slice(0, -1);
}

function metaBlock(meta: unknown): string {
    if (meta == null || (typeof meta === 'object' && Object.keys(meta as object).length === 0)) return '';
    return `\n  ${JSON.stringify(meta, null, 2)}`;
}

export const logger = {
    info(message: string, meta?: Record<string, unknown>): void {
        console.log(`[${nowTimestamp()}] [info] ${message}${metaBlock(meta)}`);
    },

    warn(message: string, meta?: Record<string, unknown>): void {
        console.warn(`[${nowTimestamp()}] [warn] ${message}${metaBlock(meta)}`);
    },

    error(message: string, error?: unknown, meta?: unknown): void {
        const errFields =
            error instanceof Error
                ? { errorName: error.name, errorMessage: error.message, stack: error.stack }
                : error !== undefined
                    ? { error }
                    : {};
        const metaFields = meta && typeof meta === 'object' && !Array.isArray(meta) ? meta : {};
        console.error(`[${nowTimestamp()}] [error] ${message}${metaBlock({ ...errFields, ...metaFields })}`);
    },
};
